import { useState, useCallback, useRef } from 'react'
import { CoffeeShopSimpleOutline } from './CoffeeShopSimpleOutline.jsx'
import useCameraStore from './store'

export function InteractiveCoffeeShop(props) {
  const [hovered, setHovered] = useState(false)
  const hoverTimeoutRef = useRef(null)
  const setHoveredElement = useCameraStore((state) => state.setHoveredElement)
  const handleElementClick = useCameraStore((state) => state.handleElementClick)
  const lastClickedElement = useCameraStore((state) => state.lastClickedElement)
  const isElementFocused = useCameraStore((state) => state.isElementFocused)

  // Check if coffee shop is currently selected
  const isSelected = lastClickedElement === 'coffee-shop' && isElementFocused

  const handleClick = useCallback((e) => {
    e.stopPropagation()
    handleElementClick('coffee-shop')
  }, [handleElementClick])

  const handlePointerOver = useCallback(() => {
    // Clear any pending hide timeout
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current)
      hoverTimeoutRef.current = null
    }
    if (!hovered) {
      setHovered(true)
      setHoveredElement('coffee-shop')
      document.body.style.cursor = 'pointer'
    }
  }, [hovered, setHoveredElement])

  const handlePointerOut = useCallback(() => {
    // Add a small delay before hiding to prevent flickering at edges
    hoverTimeoutRef.current = setTimeout(() => {
      setHovered(false)
      setHoveredElement(null)
      document.body.style.cursor = 'auto'
      hoverTimeoutRef.current = null
    }, 100)
  }, [setHoveredElement])

  return (
    <CoffeeShopSimpleOutline
      {...props}
      thickness={0.8}
      color="#35c19f"
      angle={0}
      showOutline={hovered || isSelected}
      onClick={handleClick}
      onPointerOver={handlePointerOver}
      onPointerOut={handlePointerOut}
    />
  )
}
